var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h6',{staticClass:"font-weight-bold text-h5 mb-10"},[_vm._v(" "+_vm._s(_vm.titulo)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }